<template>
	<div>
		<CRow>
			<CCol xs="12" lg="12">
				<CForm @submit.prevent="onSubmit">
				<CCard>
					<CCardHeader>
						<div class="row">
							<CCol col="6">
								<strong>{{ $lang.role.crud.edit }}</strong>
							</CCol>
						</div>
					</CCardHeader>
					<CCardBody>
						<CAlert color="danger" closeButton :show.sync="dismissCountDown" fade>
							{{ err_msg }}
						</CAlert>
							<CRow>
								<CCol>
									<div class="form-group" :class="{ 'form-group--error': $v.paymentCalculator.title.$error }">
										<label class="form__label">{{ $lang.paymentCalculator.form.title }}
											<required_span />
										</label>

										<input type="text" :placeholder="$lang.paymentCalculator.form.title"
											class="form-control" v-model="paymentCalculator.title" />

										<small class="error"
											v-if="$v.paymentCalculator.title.$error && !$v.paymentCalculator.title.required">{{
												$lang.paymentCalculator.validation.required.title }}</small>
									</div>
								</CCol>
							</CRow>
							<CRow class="align-items-center">
								<CCol>
									<div class="form-group mt-3">
										<input type="checkbox" label="Default checkbox" v-model="paymentCalculator.isGstServiceProvider" /> {{ $lang.paymentCalculator.form.isGstServiceProvider }}
									</div>
								</CCol>
								<CCol>
									<div class="form-group mt-3">
										<input type="checkbox" label="Default checkbox" v-model="paymentCalculator.isGstEndUser" /> {{ $lang.paymentCalculator.form.isGstEndUser }}
									</div>
								</CCol>
							</CRow>
							
							<CRow class="align-items-center">
								<CCol>
									<div class="form-group mt-3">
										<input type="checkbox" label="Default checkbox" v-model="paymentCalculator.isPlatformCommission" /> {{ $lang.paymentCalculator.form.isPlatformCommission }}
									</div>
								</CCol>
								<CCol>
									<div class="form-group">
										<label class="form__label">{{ $lang.paymentCalculator.form.platformCommission }}</label>

										<input type="text" :placeholder="$lang.paymentCalculator.form.platformCommission"
											class="form-control" v-model="paymentCalculator.platformCommission" />
									</div>
								</CCol>
							</CRow>
							<CRow class="align-items-center">
								<CCol>
									<div class="form-group mt-3">
										<input type="checkbox" label="Default checkbox" v-model="paymentCalculator.isGstOnPlatformCommission" /> {{ $lang.paymentCalculator.form.isGstOnPlatformCommission }}
									</div>
								</CCol>
								<CCol>
									<div class="form-group">
										<label class="form__label">{{ $lang.paymentCalculator.form.gstOnPlatformCommission }}</label>

										<input type="text" :placeholder="$lang.paymentCalculator.form.gstOnPlatformCommission"
											class="form-control" v-model="paymentCalculator.gstOnPlatformCommission" />
									</div>
								</CCol>
							</CRow>
							<CRow class="align-items-center">
								<CCol>
									<div class="form-group mt-3">
										<input type="checkbox" label="Default checkbox" v-model="paymentCalculator.isPaymentGatewayCharges" /> {{ $lang.paymentCalculator.form.isPaymentGatewayCharges }}
									</div>
								</CCol>
								<CCol>
									<div class="form-group">
										<label class="form__label">{{ $lang.paymentCalculator.form.paymentGatewayCharges }}</label>

										<input type="text" :placeholder="$lang.paymentCalculator.form.paymentGatewayCharges"
											class="form-control" v-model="paymentCalculator.paymentGatewayCharges" />
									</div>
								</CCol>
							</CRow>
							<CRow class="align-items-center">
								<CCol>
									<div class="form-group mt-3">
										<input type="checkbox" label="Default checkbox" v-model="paymentCalculator.isGstOnPaymentGatewayCharges" /> {{ $lang.paymentCalculator.form.isGstOnPaymentGatewayCharges }}
									</div>
								</CCol>
								<CCol>
									<div class="form-group">
										<label class="form__label">{{ $lang.paymentCalculator.form.gstOnPaymentGatewayCharges }}</label>

										<input type="text" :placeholder="$lang.paymentCalculator.form.gstOnPaymentGatewayCharges"
											class="form-control" v-model="paymentCalculator.gstOnPaymentGatewayCharges" />
									</div>
								</CCol>
							</CRow>
							<CRow class="align-items-center">
								<CCol>
									<div class="form-group mt-3">
										<input type="checkbox" label="Default checkbox" v-model="paymentCalculator.isGstOnService" /> {{ $lang.paymentCalculator.form.isGstOnService }}
									</div>
								</CCol>
								<CCol>
									<div class="form-group">
										<label class="form__label">{{ $lang.paymentCalculator.form.gstOnService }}</label>

										<input type="text" :placeholder="$lang.paymentCalculator.form.gstOnService"
											class="form-control" v-model="paymentCalculator.gstOnService" />
									</div>
								</CCol>
							</CRow>
							<CRow class="align-items-center">
								<CCol>
									<div class="form-group mt-3">
										<input type="checkbox" label="Default checkbox" v-model="paymentCalculator.isGstOnSubscriptionFee" /> {{ $lang.paymentCalculator.form.isGstOnSubscriptionFee }}
									</div>
								</CCol>
								<CCol>
									<div class="form-group">
										<label class="form__label">{{ $lang.paymentCalculator.form.gstOnSubscriptionFee }}</label>

										<input type="text" :placeholder="$lang.paymentCalculator.form.gstOnSubscriptionFee"
											class="form-control" v-model="paymentCalculator.gstOnSubscriptionFee" />
									</div>
								</CCol>
							</CRow>
							
							<CRow class="align-items-center">
								<CCol col="3">
									<div class="form-group mt-3">
										<input type="checkbox" label="Default checkbox" v-model="paymentCalculator.isPrePayMode" /> {{ $lang.paymentCalculator.form.isPrePayMode }}
									</div>
								</CCol>
								<CCol col="3">
									<div class="form-group mt-3">
										<input type="checkbox" label="Default checkbox" v-model="paymentCalculator.isGstOnPrePayMode" /> {{ $lang.paymentCalculator.form.isGstOnPrePayMode }}
									</div>
								</CCol>
								<CCol col="6">
									<div class="form-group">
										<label class="form__label">{{ $lang.paymentCalculator.form.gstOnPrePayMode }}</label>

										<input type="text" :placeholder="$lang.paymentCalculator.form.gstOnPrePayMode"
											class="form-control" v-model="paymentCalculator.gstOnPrePayMode" />
									</div>
								</CCol>
							</CRow>
							<CRow class="align-items-center">
								<CCol col="3">
									<div class="form-group mt-3">
										<input type="checkbox" label="Default checkbox" v-model="paymentCalculator.isRefundToUsers" /> {{ $lang.paymentCalculator.form.isRefundToUsers }}
									</div>
								</CCol>
								<CCol col="3">
									<div class="form-group mt-3">
										<input type="checkbox" label="Default checkbox" v-model="paymentCalculator.isGstOnRefundToUsers" /> {{ $lang.paymentCalculator.form.isGstOnRefundToUsers }}
									</div>
								</CCol>
								<CCol col="6">
									<div class="form-group">
										<label class="form__label">{{ $lang.paymentCalculator.form.gstOnRefundToUsers }}</label>

										<input type="text" :placeholder="$lang.paymentCalculator.form.gstOnRefundToUsers"
											class="form-control" v-model="paymentCalculator.gstOnRefundToUsers" />
									</div>
								</CCol>
							</CRow>
					</CCardBody>
					<CCardFooter>
						<CRow>
							<CCol col="6" class="text-left">
								<CButton type="submit" size="sm" color="primary" :disabled="submitted">
									<CIcon name="cil-check-circle" />
									{{ $lang.buttons.general.crud.update }}
								</CButton>
							</CCol>
						</CRow>
					</CCardFooter>
				</CCard>
			</CForm>
			</CCol>
		</CRow>
	</div>
</template>

<script>
import Vue from "vue";
import Tree from "@widgetjs/tree";
import VueForm from "vue-form";
import store from "/src/store/store.js";
import { paymentCalculator } from "/src/store/url.js";
import { Mixin } from "/src/mixins/index.js";
import options from "/src/validations/validations.js";
import { ServerTable } from "vue-tables-2";
import VueSweetalert2 from "vue-sweetalert2";
import { required } from "vuelidate/lib/validators";
import required_span from "../../components/layouts/general/required-span";
import { Maxlength } from "/src/store/maxlength";
import $ from "jquery";

Vue.use(VueSweetalert2);
Vue.use(ServerTable, {}, false);
Vue.use(VueForm, options);

export default {
	name: "PaymentCalculatorEdit",
	mixins: [Mixin],
	components: {
		required_span,
	},
	data() {
		return {
			submitted: false,
			adminId: "",
			err_msg: "",
			alertMessage: "test",
			showAlert: false,
			dismissCountDown: 0,
			dismissCountDownS: 0,
			self: this,
			msg: "",
			activePage: 1,
			module: paymentCalculator,
			editId: null,
			checked:true,
			paymentCalculator: {
				title: "",
				isGstServiceProvider: "",
				isGstEndUser: "",
				isPlatformCommission: "",
				platformCommission: "",
				isGstOnPlatformCommission: "",
				gstOnPlatformCommission: "",
				isPaymentGatewayCharges: "",
				paymentGatewayCharges: "",
				isGstOnPaymentGatewayCharges: "",
				gstOnPaymentGatewayCharges: "",
				isGstOnService: "",
				gstOnService: "",
				isGstOnSubscriptionFee: "",
				gstOnSubscriptionFee: "",
				isPrePayMode: "",
				isGstOnPrePayMode: "",
				gstOnPrePayMode: "",
				isRefundToUsers: "",
				isGstOnRefundToUsers: "",
				gstOnRefundToUsers: "",
			},
			// maxlength: {
			// 	name: Maxlength.role.name,
			// },
		};
	},

	validations: {
		paymentCalculator: {
			title: {
				required,
			},
		},
	},
	mounted() {
		let self = this;
		store.commit("showLoader", false);
		self.dismissCountDown = 0;
		self.dismissCountDownS = 0;
		if (localStorage.getItem("showAlert") !== "") {
			this.setAlert(true);
		}
		this.setAlert(false);
		localStorage.setItem("showAlert", "");

		self.editId = this.$route.params.id;
	
		axios.get(this.viewUrlApi(this.module, self.editId))
		.then(function (response) {
			if (response.status === 200) {
				const responseData = response.data.data;
				self.paymentCalculator.title = responseData.title;
				self.paymentCalculator.isGstServiceProvider = responseData.isGstServiceProvider;
				self.paymentCalculator.isGstEndUser = responseData.isGstEndUser;
				self.paymentCalculator.isPlatformCommission = responseData.isPlatformCommission;
				self.paymentCalculator.platformCommission = responseData.platformCommission;
				self.paymentCalculator.isGstOnPlatformCommission = responseData.isGstOnPlatformCommission;
				self.paymentCalculator.gstOnPlatformCommission = responseData.gstOnPlatformCommission;
				self.paymentCalculator.isPaymentGatewayCharges = responseData.isPaymentGatewayCharges;
				self.paymentCalculator.paymentGatewayCharges = responseData.paymentGatewayCharges;
				self.paymentCalculator.isGstOnPaymentGatewayCharges = responseData.isGstOnPaymentGatewayCharges;
				self.paymentCalculator.gstOnPaymentGatewayCharges = responseData.gstOnPaymentGatewayCharges;
				self.paymentCalculator.isGstOnService = responseData.isGstOnService;
				self.paymentCalculator.gstOnService = responseData.gstOnService;
				self.paymentCalculator.isGstOnSubscriptionFee = responseData.isGstOnSubscriptionFee;
				self.paymentCalculator.gstOnSubscriptionFee = responseData.gstOnSubscriptionFee;
				self.paymentCalculator.isPrePayMode = responseData.isPrePayMode;
				self.paymentCalculator.isGstOnPrePayMode = responseData.isGstOnPrePayMode;
				self.paymentCalculator.gstOnPrePayMode = responseData.gstOnPrePayMode;
				self.paymentCalculator.isRefundToUsers = responseData.isRefundToUsers;
				self.paymentCalculator.isGstOnRefundToUsers = responseData.isGstOnRefundToUsers;
				self.paymentCalculator.gstOnRefundToUsers = responseData.gstOnRefundToUsers;
			}
        });
	},
	watch: {
		$route: {
			immediate: true,
			handler(route) {
				if (route.query && route.query.page) {
					this.activePage = Number(route.query.page);
				}
			},
		},
	},
	methods: {
		onSubmit() {
			this.$v.paymentCalculator.$touch();
			if (this.$v.paymentCalculator.$invalid) {
				this.submitted = false; //Enable Button
				this.submitStatus = "ERROR";
			} else {
				this.submitted = true; //Disable Button

				// upload file
				let self = this;
				const postData = {
					title:self.paymentCalculator.title,
					is_gst_service_provider:self.paymentCalculator.isGstServiceProvider,
					is_gst_end_user:self.paymentCalculator.isGstEndUser,
					is_platform_commission:self.paymentCalculator.isPlatformCommission,
					platform_commission:self.paymentCalculator.platformCommission,
					is_gst_on_platform_commission:self.paymentCalculator.isGstOnPlatformCommission,
					gst_on_platform_commission:self.paymentCalculator.gstOnPlatformCommission,
					is_payment_gateway_charges:self.paymentCalculator.isPaymentGatewayCharges,
					payment_gateway_charges:self.paymentCalculator.paymentGatewayCharges,
					is_gst_on_payment_gateway_charges:self.paymentCalculator.isGstOnPaymentGatewayCharges,
					gst_on_payment_gateway_charges:self.paymentCalculator.gstOnPaymentGatewayCharges,
					is_gst_on_service:self.paymentCalculator.isGstOnService,
					gst_on_service:self.paymentCalculator.gstOnService,
					is_gst_on_subscription_fee:self.paymentCalculator.isGstOnSubscriptionFee,
					gst_on_subscription_fee:self.paymentCalculator.gstOnSubscriptionFee,
					is_pre_pay_mode:self.paymentCalculator.isPrePayMode,
					is_gst_on_pre_pay_mode:self.paymentCalculator.isGstOnPrePayMode,
					gst_on_pre_pay_mode:self.paymentCalculator.gstOnPrePayMode,
					is_refund_to_users:self.paymentCalculator.isRefundToUsers,
					is_gst_on_refund_to_users:self.paymentCalculator.isGstOnRefundToUsers,
					gst_on_refund_to_users:self.paymentCalculator.gstOnRefundToUsers,
				};
				
				axios.post(this.updateUrlweb(this.module, self.editId), postData)
				.then((response) => {
					if (response.data.code === 200) {
						self.err_msg = response.data.message;
						localStorage.setItem("notificationType", "success");
						localStorage.setItem(
							"notificationMessage",
							response.data.message
						);
						self.dismissCountDown = 10;
						
						self.$router.push({
							path: '/payment-calculator'
						});
					} else {
						self.err_msg = response.data.response.message;
						self.dismissCountDown = 10;
						self.submitted = false; //Enable Button
					}
				}).catch(function (error) {
					let data;
					if (error.response.data.error) {
						data = error.response.data.error.toString();
					} else {
						data = error.response.data.message;
					}
					self.err_msg = data;
					self.dismissCountDown = 10;
					self.submitted = false; //Enable Button
				});
			}
		},
		setAlert(value) {
			this.showAlert = value;
		},
	},
};
</script>

<style>
#app {
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;
	color: #2c3e50;
	margin-top: 60px;
}
</style>
